import {
  Person as AccountIcon,
  Create,
  Lock,
  Mail,
  Menu as MenuIcon,
  MenuOpen,
  Person,
  Send as SendIcon,
  VpnKey
} from "@mui/icons-material";
import {
  AppBar,
  Fab,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Tab,
  Tabs,
  Toolbar
} from "@mui/material";
import classNames from "classnames";
import React, { useState } from "react";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../../assets/logo.png';

// styles
import useStyles from "./styles";

// components
import Notification from "../Notification/Notification";
import UserAvatar from "../UserAvatar/UserAvatar";
import { Typography } from "../Wrappers";

// context
import { Form } from "antd";
import { encode as btoa } from 'base-64';
// import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useNavigate } from "react-router-dom";
import { Constant } from "../../constant";
import {
  toggleSidebar,
  useLayoutDispatch,
  useLayoutState,
} from "../../context/LayoutContext";
import { signOut, useUserDispatch } from "../../context/UserContext";
import { NormalAlert } from '../../export/AlertMessage';
import BaliseChamp from '../../export/BaliseChamp';
import { Buttons, ButtonsItem, Inputs, PhoneInput } from '../../export/InputsChamp';
import Service from "../../service";

const messages = [
  {
    id: 0,
    variant: "warning",
    name: "Jane Hew",
    message: "Hey! How is it going?",
    time: "9:32",
  },
  {
    id: 1,
    variant: "success",
    name: "Lloyd Brown",
    message: "Check out my new Dashboard",
    time: "9:18",
  },
  {
    id: 2,
    variant: "primary",
    name: "Mark Winstein",
    message: "I want rearrange the appointment",
    time: "9:15",
  },
  {
    id: 3,
    variant: "secondary",
    name: "Liana Dutti",
    message: "Good news from sale department",
    time: "9:09",
  },
];

const notifications = [
  { id: 0, color: "warning", message: "Check out this awesome ticket" },
  {
    id: 1,
    color: "success",
    type: "info",
    message: "What is the best way to get ...",
  },
  {
    id: 2,
    color: "secondary",
    type: "notification",
    message: "This is just a simple notification",
  },
  {
    id: 3,
    color: "primary",
    type: "e-commerce",
    message: "12 new orders has arrived today",
  },
];

let user = JSON.parse(localStorage.getItem("user"));
const envoicodemessage = "Nous venons de vous envoyez un code de verification sur votre mail : ";
let mail = "";
export default function Header(props) {
  var classes = useStyles();
  const navigate = useNavigate();
  // if(window.location.hostname.includes("gps.sevob.net")) {
  //   navigate('/maps/error')
  // }

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();

  // local
  var [mailMenu, setMailMenu] = useState(null);
  var [isMailsUnread, setIsMailsUnread] = useState(true);
  var [notificationsMenu, setNotificationsMenu] = useState(null);
  var [isNotificationsUnread, setIsNotificationsUnread] = useState(true);
  var [profileMenu, setProfileMenu] = useState(null);
  var [isSearchOpen, setSearchOpen] = useState(false);
  var [open, setOpen] = useState(false);
  const [form] = Form.useForm()
  const [value, setValue] = React.useState(0);
  const [etape, setEtape] = React.useState(0);
  const [titre, setTitre] = useState(Constant.fr.seconnecter);
  const [etapeInscrit, setEtapeInscrit] = React.useState({value: 0, code: ""});
  const [spinner, setSpinner] = useState(false);
  const [text, setText] = useState("Veuillez saisir le mail que vous utilisez sur SEVOB");
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = React.useState({
    id:0,
    nom: "",
    telephone: "",
    user: {
      id: 0,
      nomUtilisateur: "",
      motDePasse: "",
    }
  });
  const [error, setError] = React.useState({
    nom: false,
    telephone: false,
    nomUtilisateur: false,
    motDePasse: false,
  });
  const [values, setValues] = React.useState({showPassword: false});



  const InscriptionChamps = () => {
    let champs = [
        Inputs({
            label: Constant.fr.nomIndividuEntreprise,
            name: "nomcomplet",
            rules: [
              {required: true, message: Constant.fr.champsObligatoire}
            ],
            type: "text",
            typeChamps: Constant.baliseData.typeChamp.Inputs,
            styles: styles.input,
            allowClear: true,
            // helpMessage: <small style={{color: 'red', fontSize: 10}}>{Constant.fr.telephoneParDefaut}</small>,
            xs: 24,
            prefix: <Person />
          }),
          PhoneInput({
            label: Constant.fr.telephone,
            name: "telephone",
            rules: [
              {required: true, message: Constant.fr.champsObligatoire},
            ],
            placeholder: Constant.fr.numero,
            international: true,
            typeChamps: Constant.baliseData.typeChamp.Phone,
            styles: styles.input,
            xs: 24,
            formItemStyles:{margin: 0}
          }),
        Inputs({
            label: Constant.fr.Email,
            name: "username",
            rules: [
              {required: true, message: Constant.fr.champsObligatoire},
              {type: 'email', message: Constant.fr.emailNoValid},
            ],
            type: "text",
            typeChamps: Constant.baliseData.typeChamp.Inputs,
            styles: styles.input,
            allowClear: true,
            // helpMessage: <small style={{color: 'red', fontSize: 10}}>{Constant.fr.telephoneParDefaut}</small>,
            xs: 24,
            prefix: <Mail />
          }),
        Inputs({
            label: Constant.fr.password,
            name: "password",
            rules: [{required: true, message: Constant.fr.champsObligatoire}],
            type: "password",
            typeChamps: Constant.baliseData.typeChamp.Inputs,
            styles: styles.input,
            allowClear: true,
            xs: 24,
            prefix: <VpnKey />
          }),
      Buttons([
        ButtonsItem({
          text: Constant.fr.sinscrire,
          size: Constant.baliseData.size.large,
          typeChamps: Constant.baliseData.typeChamp.Buttons,
          onPress: Constant.baliseData.onPress.validate,
          colStyle: [{marginRight: 10}],
          styles: {color: Constant.couleur.secondary, borderColor: Constant.couleur.secondary},
          rowBalise: true,
          spinner: true,
          variant:"outlined",
          // textStyles: {color: "white", fontSize: 18},
          // activeStyle: [{backgroundColor: Constant.couleur.primary}],
        }),
        ButtonsItem({
          text: Constant.fr.Fermer,
          size: Constant.baliseData.size.large,
          typeChamps: Constant.baliseData.typeChamp.Buttons,
          onPress: Constant.baliseData.onPress.return,
          colStyle: [{marginRight: 10}],
          variant:"outlined",
          rowBalise: true,
        }),
      ],
      {
        rowBalise: true,
        spaceBetween: true,
        xs: 24
      }),
    ];

    return champs
  }

  const ConnexionChamps = () => {
    let champs = [
        Inputs({
            label: Constant.fr.Email,
            name: "username",
            rules: [
              {required: true, message: Constant.fr.champsObligatoire},
              {type: 'email', message: Constant.fr.emailNoValid},
            ],
            type: "text",
            typeChamps: Constant.baliseData.typeChamp.Inputs,
            styles: styles.input,
            allowClear: true,
            // helpMessage: <small style={{color: 'red', fontSize: 10}}>{Constant.fr.telephoneParDefaut}</small>,
            xs: 24,
            prefix: <Mail />
          }),
        Inputs({
            label: Constant.fr.password,
            name: "password",
            rules: [{required: true, message: Constant.fr.champsObligatoire}],
            type: "password",
            typeChamps: Constant.baliseData.typeChamp.Inputs,
            styles: styles.input,
            allowClear: true,
            xs: 24,
            prefix: <VpnKey />
          }),
      Buttons([
        ButtonsItem({
          text: Constant.fr.seconnecter,
          size: Constant.baliseData.size.large,
          typeChamps: Constant.baliseData.typeChamp.Buttons,
          onPress: Constant.baliseData.onPress.validate,
          colStyle: [{marginRight: 10}],
          styles: {color: Constant.couleur.secondary, borderColor: Constant.couleur.secondary},
          rowBalise: true,
          spinner: true,
          variant:"outlined",
          // textStyles: {color: "white", fontSize: 18},
          // activeStyle: [{backgroundColor: Constant.couleur.primary}],
        }),
        ButtonsItem({
          text: Constant.fr.Fermer,
          size: Constant.baliseData.size.large,
          typeChamps: Constant.baliseData.typeChamp.Buttons,
          onPress: Constant.baliseData.onPress.return,
          colStyle: [{marginRight: 10}],
          variant:"outlined",
          rowBalise: true,
        }),
      ],
      {
        rowBalise: true,
        spaceBetween: true,
        xs: 24
      }),
    ];

    return champs
  }

  const CodeChamps = () => {
    let champs = [
        Inputs({
            label: Constant.fr.code,
            name: "code",
            rules: [{required: true, message: Constant.fr.champsObligatoire}],
            type: "text",
            typeChamps: Constant.baliseData.typeChamp.Inputs,
            styles: styles.input,
            allowClear: true,
            xs: 24,
            prefix: <VpnKey />
          }),
      Buttons([
        ButtonsItem({
          text: Constant.fr.Verifier,
          size: Constant.baliseData.size.large,
          typeChamps: Constant.baliseData.typeChamp.Buttons,
          onPress: Constant.baliseData.onPress.validate,
          colStyle: [{marginRight: 10}],
          styles: {color: Constant.couleur.secondary, borderColor: Constant.couleur.secondary},
          rowBalise: true,
          spinner: true,
          variant:"outlined",
          // textStyles: {color: "white", fontSize: 18},
          // activeStyle: [{backgroundColor: Constant.couleur.primary}],
        }),
        ButtonsItem({
          text: Constant.fr.Fermer,
          size: Constant.baliseData.size.large,
          typeChamps: Constant.baliseData.typeChamp.Buttons,
          onPress: Constant.baliseData.onPress.return,
          colStyle: [{marginRight: 10}],
          variant:"outlined",
          rowBalise: true,
        }),
      ],
      {
        rowBalise: true,
        spaceBetween: true,
        xs: 24
      }),
    ];

    return champs
  }

  const MotDePasseOublierChamps = () => {
    let champs = [
          Inputs({
            label: Constant.fr.Email,
            name: "email",
            rules: [
              {required: true, message: Constant.fr.champsObligatoire},
              {type: 'email', message: Constant.fr.emailNoValid},
            ],
            type: "text",
            typeChamps: Constant.baliseData.typeChamp.Inputs,
            styles: styles.input,
            allowClear: true,
            // helpMessage: <small style={{color: 'red', fontSize: 10}}>{Constant.fr.telephoneParDefaut}</small>,
            xs: 24,
            prefix: <Mail />
          }),
      Buttons([
        ButtonsItem({
          text: Constant.fr.send,
          size: Constant.baliseData.size.large,
          typeChamps: Constant.baliseData.typeChamp.Buttons,
          onPress: Constant.baliseData.onPress.validate,
          colStyle: [{marginRight: 10}],
          styles: {color: Constant.couleur.secondary, borderColor: Constant.couleur.secondary},
          rowBalise: true,
          spinner: true,
          variant:"outlined",
          // textStyles: {color: "white", fontSize: 18},
          // activeStyle: [{backgroundColor: Constant.couleur.primary}],
        }),
        ButtonsItem({
          text: Constant.fr.Fermer,
          size: Constant.baliseData.size.large,
          typeChamps: Constant.baliseData.typeChamp.Buttons,
          onPress: Constant.baliseData.onPress.return,
          colStyle: [{marginRight: 10}],
          variant:"outlined",
          rowBalise: true,
        }),
      ],
      {
        rowBalise: true,
        spaceBetween: true,
        xs: 24
      }),
    ];

    return champs
  }
  const NouveauMotDePasseChamps = () => {
    let champs = [
        Inputs({
            label: Constant.fr.nouveaupassword,
            name: "newPassword",
            rules: [{required: true, message: Constant.fr.champsObligatoire}],
            type: "password",
            typeChamps: Constant.baliseData.typeChamp.Inputs,
            styles: styles.input,
            allowClear: true,
            xs: 24,
            prefix: <VpnKey />
          }),
        Inputs({
            label: Constant.fr.confirmationpassword,
            name: "confirmPassword",
            rules: [{required: true, message: Constant.fr.champsObligatoire}],
            type: "password",
            typeChamps: Constant.baliseData.typeChamp.Inputs,
            styles: styles.input,
            allowClear: true,
            xs: 24,
            prefix: <VpnKey />
          }),
      Buttons([
        ButtonsItem({
          text: Constant.fr.Modifier,
          size: Constant.baliseData.size.large,
          typeChamps: Constant.baliseData.typeChamp.Buttons,
          onPress: Constant.baliseData.onPress.validate,
          colStyle: [{marginRight: 10}],
          styles: {color: Constant.couleur.secondary, borderColor: Constant.couleur.secondary},
          rowBalise: true,
          spinner: true,
          variant:"outlined",
          // textStyles: {color: "white", fontSize: 18},
          // activeStyle: [{backgroundColor: Constant.couleur.primary}],
        }),
        ButtonsItem({
          text: Constant.fr.Fermer,
          size: Constant.baliseData.size.large,
          typeChamps: Constant.baliseData.typeChamp.Buttons,
          onPress: Constant.baliseData.onPress.return,
          colStyle: [{marginRight: 10}],
          variant:"outlined",
          rowBalise: true,
          // textStyles: {color: Constant.couleur.secondary},
        //   activeStyle: [{backgroundColor: Constant.couleur.primary}],
        }),
      ],
      {
        rowBalise: true,
        spaceBetween: true,
        xs: 24
      }),
    ];

    return champs
  }
  const [formState, setFormState]= useState({
    champs: ConnexionChamps(),
    layoutForm:Constant.baliseData.layoutForm.vertical,
    initialValues: {
    }
  })
  const onSubmit = () => {
    form.submit()
  }
  const retourBouton = (element) => {
    if(element.text === Constant.fr.Fermer) {
      setOpen(false)
    } else if(element.text === Constant.fr.code) {
        setTitre(Constant.fr.code)
        setFormState({...formState, champs: CodeChamps()})
    } else if(element.text === Constant.fr.nouveaupassword) {
        setTitre(Constant.fr.nouveaupassword)
        setFormState({...formState, champs: NouveauMotDePasseChamps()})
    } else if(element.text === Constant.fr.seconnecter) {
        setValue(0);
        setTitre(Constant.fr.seconnecter)
        setFormState({...formState, champs: ConnexionChamps()})
    }
  }
  const onFinish = (values) => {
    if(values.nomcomplet !== undefined) {
        SInscrire(values)
    } else if(values.username !== undefined && values.password !== undefined) {
        SeConnecter(values)
    } else if(values.email !== undefined) {
        SendEmail(values)
    } else if(values.code !== undefined) {
        Verification(values)
    }else if(values.newPassword !== undefined) {
        if(values.newPassword !== values.confirmPassword) {
            NormalAlert("error", Constant.fr.motDePasseConfirmationDifferent)
        } else {
            ChangeMotDePasse(values)
        }
    }
  }
  const returnValue = (name, value) => {
  }
  const ChangeMotDePasse = (values) => {
    setSpinner(true);
    values.email = email;
        Service.post(Constant.paths.ModificationMotDePasse, "", values, false).then(
          async (reponse) => {
            setSpinner(false);
            if(reponse.status === 200 || reponse.status === 201){
                retourBouton({
                    text: Constant.fr.seconnecter
                })
                setText("");
                NormalAlert("success",reponse.data);
              }
          }, error => {
            setSpinner(false);
            if(error.response !== undefined && error.response.data !== undefined  && error.response.data.message !== undefined) {
                NormalAlert("error", error.response.data.message);
            } else {
                NormalAlert("error", Constant.fr.erreurServeur);
            }
          }
        )
  };
  const Verification = (values) => {
    setSpinner(true);
        Service.getAll(Constant.paths.VerificationCode, {
            params: {
                code: values.code,
                email: email,
            }}, false).then(
          async (reponse) => {
            setSpinner(false);
            if(reponse.status === 200){
                retourBouton({
                    text: Constant.fr.nouveaupassword
                })
                setText(reponse.data.message);
                NormalAlert("success", reponse.data.message);
              } else {
                NormalAlert("error", reponse.data.message);
              }
          }, error => {
            setSpinner(false);
            if(error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined) {
                NormalAlert("error", error.response.data.message);
            } else {
                NormalAlert("error", Constant.fr.erreurServeur);
            }
          }
        )
  };
  const SendEmail = (values) => {
    setSpinner(true);
        Service.post(Constant.paths.SendCode, "", values, false).then(
          async (reponse) => {
            setSpinner(false);
            if(reponse.status === 200 || reponse.status === 201){
              setEmail(values.email);
              retourBouton({
                text: Constant.fr.code,
              })
                setText(reponse.data);
                NormalAlert("success",reponse.data);
              }
            
          }, error => {
              setSpinner(false);
              if(error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined) {
                NormalAlert("error", error.response.data.message);
            } else {
                NormalAlert("error", Constant.fr.erreurServeur);
            }
          }
        )
  };
  const SInscrire = (values) => {
    setSpinner(true);
        Service.post(Constant.paths.addClient, "", values, false).then(
          async (reponse) => {
            setSpinner(false);
            if(reponse.status === 200 || reponse.status === 201){
              retourBouton({
                  text: Constant.fr.seconnecter
              })
              setText("");
              NormalAlert("success",reponse.data);
            }
          }, error => {
            setSpinner(false);
            if(error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined) {
                NormalAlert("error", error.response.data.message);
            } else {
                NormalAlert("error", Constant.fr.accesRefuse);
            }
          }
        )
  };
  const SeConnecter = (values) => {
    setSpinner(true);
        Service.post(Constant.paths.login, "", values, false).then(
          async (response) => {
            setSpinner(false);
            localStorage.setItem(Constant.userLocal, JSON.stringify(response.data));
            localStorage.setItem(Constant.tokenLocal, response.data.token);
            window.location.reload()
          }, error => {
            setSpinner(false);
            if(error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined) {
                NormalAlert("error", error.response.data.message);
            } else {
                NormalAlert("error", Constant.fr.accesRefuse);
            }
          }
        )
  };
  const onFinishFailed = (errorInfo) => {
    setSpinner(false);
    NormalAlert("warning", 
      Constant.fr.renseignerChampsObligatoire
    )
  };




  React.useEffect(() => {
  }, [])

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if(newValue === 2) {
        setFormState({...formState, champs: MotDePasseOublierChamps()})
    } else if(newValue === 0) {
        setTitre(Constant.fr.seconnecter)
        setFormState({...formState, champs: ConnexionChamps()})
    } else if(newValue === 1) {
        setTitre(Constant.fr.Inscription)
        setFormState({...formState, champs: InscriptionChamps()})
    }
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const cliquer = () => {
    if(state.nom.trim() === "" && value === 1){
      setError({...error, nom: true})
    } else if(state.telephone.trim() === "" && value === 1){
      setError({...error, telephone: true, nom: false})
    } else if((state.user.nomUtilisateur.trim() === "" || (state.user.nomUtilisateur.split("@")[1] === undefined && etape !== 1)) && (etape !== 2)){
      setError({...error, nomUtilisateur: true, telephone: false, nom: false})
    } else if((state.user.motDePasse.trim() === "" && etape !== 0) && (state.user.motDePasse.trim() === "" && etape !== 1)){
      setError({...error, motDePasse: true, nomUtilisateur: false, telephone: false, nom: false})
    } else {
      setError({...error, motDePasse: false, nomUtilisateur: false, telephone: false, nom: false})
      if(value === 0) {
        Connexion()
      } else if(value === 1 && etapeInscrit.value === 0) {
        EnvoiCodeInscription()
      } else if(value === 1 && etapeInscrit.value === 1) {
        VerificationInscription()
      } else {
        if(etape === 0){
          EnvoiCode()
        } else if(etape === 1){
          Verification()
        } else {
          Modification()
        }
        // if(value === 2 && etape !== 2) {
        //   setEtape(etape+1);
        // }
      } 
    }
  };

  const Connexion = () => {
    setSpinner(true);
        const token = btoa(state.user.nomUtilisateur.toString() + ':' + state.user.motDePasse);
        Service.connexion(token, state.user.nomUtilisateur).then(
          async (response) => {
            setSpinner(false);
            setOpen(false)
              localStorage.setItem('user', JSON.stringify(response.data));
              localStorage.setItem('token', token);
              window.location.reload();
              // history.push('/app/dashboard')
              // navigation.navigate("MainDrawer");
          }, error => {
              setSpinner(false);
              toast.error("Erreur de connexion. Merci de nous contacter si l'erreur persiste", {position: "top-center", autoClose: 10000,})
        
          }
        )
  };
  const Inscription = () => {
    setSpinner(true);
    Service.inscription(state).then(
      async (response) => {
        setSpinner(false);
        if(response !== undefined) {
          setValue(0)
          toast.success(response.data, {position: "top-center", autoClose: 10000,})
        } else {
          toast.error("Erreur lors de l'envoi de l'email.\nMerci de verifier que votre adresse mail est correct.", {position: "top-center", autoClose: 10000,})
        }
      }, error => {
        toast.error("Erreur de connexion. Merci de nous contacter si l'erreur persiste", {position: "top-center", autoClose: 10000,})
        setSpinner(false);
      }
    )
  };


  const EnvoiCodeInscription = () => {
    setSpinner(true);
    const coderesult = makeid(6);
    Service.envoiCodeInscription(state.user.nomUtilisateur, coderesult, state.nom).then(
      (response) => {
          setSpinner(false);
          setCode(coderesult)
          setEtapeInscrit({...etapeInscrit, value: 1})
          setText("Veuillez saisir le code que vous avez reçu à : " + state.user.nomUtilisateur)
          toast.success(envoicodemessage + state.user.nomUtilisateur, {position: "top-center", autoClose: 10000,})
      }, error => {
        setSpinner(false);
        toast.error("Erreur de connexion. Merci de nous contacter si l'erreur persiste", {position: "top-center", autoClose: 10000,})
      }
    )
  };

  const VerificationInscription = () => {
    if (etapeInscrit.code === code) {
      setSpinner(false)
      Inscription()
    } else {
      toast.error("Code incorrect", {position: "top-center", autoClose: 10000,})
      setSpinner(false)
    }
  };

  function makeid(length) {
    var result           = [];
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result.push(characters.charAt(Math.floor(Math.random() * 
      charactersLength)));
   }
   return result.join('');
}

  const EnvoiCode = () => {
    setSpinner(true);
    const coderesult = makeid(6);
    Service.envoiCode(state.user.nomUtilisateur, coderesult).then(
      (response) => {
        setSpinner(false);
        if(response.data === 1 ) {
          toast.error("Cet E-mail n\'existe pas", {position: "top-center", autoClose: 10000,})
        } else {
          mail = state.user.nomUtilisateur;
          setState({...state, user: {...state.user, nomUtilisateur: ""}})
          setEtape(1);
          setCode(coderesult)
          setText("Veuillez saisir le code que vous avez reçu à : " + mail)
          toast.success(envoicodemessage + mail, {position: "top-center", autoClose: 10000,})
        }
      }, error => {
        setSpinner(false);
        toast.error("Erreur de connexion. Merci de nous contacter si l'erreur persiste", {position: "top-center", autoClose: 10000,})
      }
    )
  };
  const VerificationANcien = () => {
    if (state.user.nomUtilisateur === code) {
      setText("Veuillez saisir votre nouveau mot de passe");
      setEtape(2);
      setSpinner(false)
    } else {
      toast.error("Code incorrect", {position: "top-center", autoClose: 10000,})
      setSpinner(false)
    }
  };
  const Modification = () => {
    setSpinner(true);
    Service.ModificationMotDePasse(mail, state.user.motDePasse).then(
      (response) => {
        setValue(0);
        setEtape(0)
        setState({...state, user: {...state.user, nomUtilisateur: mail}})
        setSpinner(false);
        toast.success("Votre mot de passe à été modifié avec succès", {position: "top-center", autoClose: 10000,})
      }, error => {
        setSpinner(false);
        toast.success("Erreur de modification. Merci de réessayer", {position: "top-center", autoClose: 10000,})
      }
    )
  };

  return (
      <div>
        <ToastContainer />
        <AppBar position="fixed" className={classes.appBar} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <Toolbar className={classes.toolbar}>
          {(user !== null && user !== undefined) &&
            <IconButton
              color="inherit"
              onClick={() => toggleSidebar(layoutDispatch)}
              className={classNames(
                classes.headerMenuButtonSandwich,
                classes.headerMenuButtonCollapse,
              )}
            >
              {layoutState.isSidebarOpened ? (
                <MenuOpen
                  classes={{
                    root: classNames(
                      classes.headerIcon,
                      classes.headerIconCollapse,
                    ),
                  }}
                />
              ) : (
                <MenuIcon
                  classes={{
                    root: classNames(
                      classes.headerIcon,
                      classes.headerIconCollapse,
                    ),
                  }}
                />
              )}
            </IconButton>
          }
            <img src={logo} alt="logo" style={{height: 50, borderRadius: 5}} />
            {/* <Typography variant="h6" weight="medium" className={classes.logotype}>
              SEVOB
            </Typography> */}
            <div className={classes.grow} />
            {/* <div
              className={classNames(classes.search, {
                [classes.searchFocused]: isSearchOpen,
              })}
            >
              <div
                className={classNames(classes.searchIcon, {
                  [classes.searchIconOpened]: isSearchOpen,
                })}
                onClick={() => setSearchOpen(!isSearchOpen)}
              >
                <SearchIcon classes={{ root: classes.headerIcon }} />
              </div>
              <InputBase
                placeholder="Search…"
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
              />
            </div>
            <IconButton
              color="inherit"
              aria-haspopup="true"
              aria-controls="mail-menu"
              onClick={e => {
                setNotificationsMenu(e.currentTarget);
                setIsNotificationsUnread(false);
              }}
              className={classes.headerMenuButton}
            >
              <Badge
                badgeContent={isNotificationsUnread ? notifications.length : null}
                color="warning"
              >
                <NotificationsIcon classes={{ root: classes.headerIcon }} />
              </Badge>
            </IconButton>
            <IconButton
              color="inherit"
              aria-haspopup="true"
              aria-controls="mail-menu"
              onClick={e => {
                setMailMenu(e.currentTarget);
                setIsMailsUnread(false);
              }}
              className={classes.headerMenuButton}
            >
              <Badge
                badgeContent={isMailsUnread ? messages.length : null}
                color="secondary"
              >
                <MailIcon classes={{ root: classes.headerIcon }} />
              </Badge>
            </IconButton> */}
            {(user === null || user === undefined) &&
              <div variant={"outlined"} className={classes.headerMenuButton}>
                  <IconButton
                    aria-haspopup="true"
                    className={classes.headerMenuButton}
                    onClick={(e)=> setOpen(true)}
                    style={{color: 'white'}}
                    >
                    <AccountIcon classes={{ root: classes.headerIcon }} /> Identification
                  </IconButton>
              </div>
            }
            {(user !== null && user !== undefined) &&
              <IconButton
                aria-haspopup="true"
                color="inherit"
                className={classes.headerMenuButton}
                aria-controls="profile-menu"
                onClick={e => setProfileMenu(e.currentTarget)}
              >
                <AccountIcon classes={{ root: classes.headerIcon }} /> {(user !== null && user !== undefined) && user.nomcomplet}
              </IconButton>
            }
            <Menu
              id="mail-menu"
              open={Boolean(mailMenu)}
              anchorEl={mailMenu}
              onClose={() => setMailMenu(null)}
              MenuListProps={{ className: classes.headerMenuList }}
              className={classes.headerMenu}
              classes={{ paper: classes.profileMenu }}
              disableAutoFocusItem
            >
              <div className={classes.profileMenuUser}>
                <Typography variant="h4" weight="medium">
                  New Messages
                </Typography>
                <Typography
                  className={classes.profileMenuLink}
                  component="a"
                  color="secondary"
                >
                  {messages.length} New Messages
                </Typography>
              </div>
              {messages.map(message => (
                <MenuItem key={message.id} className={classes.messageNotification}>
                  <div className={classes.messageNotificationSide}>
                    <UserAvatar color={message.variant} name={message.name} />
                    <Typography size="sm" color="text" colorBrightness="secondary">
                      {message.time}
                    </Typography>
                  </div>
                  <div
                    className={classNames(
                      classes.messageNotificationSide,
                      classes.messageNotificationBodySide,
                    )}
                  >
                    <Typography weight="medium" gutterBottom>
                      {message.name}
                    </Typography>
                    <Typography color="text" colorBrightness="secondary">
                      {message.message}
                    </Typography>
                  </div>
                </MenuItem>
              ))}
              <Fab
                variant="extended"
                color="primary"
                aria-label="Add"
                className={classes.sendMessageButton}
              >
                Send New Message
                <SendIcon className={classes.sendButtonIcon} />
              </Fab>
            </Menu>
            <Menu
              id="notifications-menu"
              open={Boolean(notificationsMenu)}
              anchorEl={notificationsMenu}
              onClose={() => setNotificationsMenu(null)}
              className={classes.headerMenu}
              disableAutoFocusItem
            >
              {notifications.map(notification => (
                <MenuItem
                  key={notification.id}
                  onClick={() => setNotificationsMenu(null)}
                  className={classes.headerMenuItem}
                >
                  <Notification {...notification} typographyVariant="inherit" />
                </MenuItem>
              ))}
            </Menu>
            <Menu
              id="profile-menu"
              open={Boolean(profileMenu)}
              anchorEl={profileMenu}
              onClose={() => setProfileMenu(null)}
              className={classes.headerMenu}
              classes={{ paper: classes.profileMenu }}
              disableAutoFocusItem
              onClick={(e) => navigate('/app/Profil')}
            >
              <div className={classes.profileMenuUser}>
                <Typography variant="h4" weight="medium">
                  {(user !== null && user !== undefined) && user.nomcomplet}
                </Typography>
                <Typography
                  className={classes.profileMenuLink}
                  component="a"
                  color="primary"
                >
                  {(user !== null && user !== undefined) && user.user.username}
                </Typography>
              </div>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
                
              >
                <AccountIcon className={classes.profileMenuIcon} /> Profil
              </MenuItem>
              {/* <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                <AccountIcon className={classes.profileMenuIcon} /> Tasks
              </MenuItem>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                <AccountIcon className={classes.profileMenuIcon} /> Messages
              </MenuItem> */}
              <div className={classes.profileMenuUser}>
                <Typography
                  className={classes.profileMenuLink}
                  color="error"
                  onClick={() => signOut(userDispatch, props.history)}
                >
                  Déconnexion
                </Typography>
              </div>
            </Menu>
          </Toolbar>

          <Modal
            open={open}
            onClose={(e)=>setOpen(false)}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{zIndex: 1000, overflow: 'scroll'}}
          >
            <div>
            <Grid container spacing={3}>
                <Grid item md={3}>
                </Grid>
                <Grid item md={6}>
                  <Paper square  style={{paddingTop: 60, paddingBottom: 50, borderBottomLeftRadius: 20, borderBottomRightRadius: 20}}>
                    <Tabs
                      value={value}
                      indicatorColor="secondary"
                      textColor="secondary"
                      onChange={handleChange}
                      variant="fullWidth"
                      aria-label="disabled tabs example"
                    >
                      <Tab label={Constant.fr.Connexion} icon={<Lock />}/>
                      <Tab label={Constant.fr.Inscription} icon={<Create />}/>
                      <Tab label={Constant.fr.motDePasseOublie} icon={<VpnKey />} />
                    </Tabs>

                  <h1 style={{textAlign: 'center', color: Constant.couleurPrimaire, marginTop: 50}}>
                    {value === 0 && Constant.fr.Connexion}
                    {value === 1 && Constant.fr.Inscription}
                    {value === 2 && Constant.fr.motDePasseOublie}
                  </h1>

                  {(value === 2 || (value === 1 && etapeInscrit.value === 1)) && <p style={{textAlign: 'center', marginBottom: 10, color: 'red'}}>{text}</p>}
                  <Grid container spacing={3}>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={8}>
                          <Grid container spacing={3}>
                            <div style={{ paddingVertical: 10, backgroundColor: Constant.couleur.white, padding: 20, borderRadius: 10}}>
                                  <Form
                                      name="connexion"
                                      form={form}
                                      onFinish={onFinish}
                                      onFinishFailed={onFinishFailed}
                                      layout={formState.layoutForm} 
                                      initialValues={formState.initialValues}
                                      >
                                          <BaliseChamp prop={props} spinnerBouton={spinner} form={form} formState={formState} onSubmit={onSubmit.bind()} return={retourBouton.bind()} returnValue={returnValue.bind()}/>
                                  </Form>
                            </div>
                          </Grid>
                      </Grid>
                      <Grid item xs={2}></Grid>
                  </Grid>
                  </Paper>
                </Grid>
                <Grid item md={3}>
                </Grid>
            </Grid>
            </div>
          </Modal>

        </AppBar>
      </div>
  );
}

const styles = {
  headerContainer: {
    height: 52,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingBottom: 0,
  },
  headerText: {
    flex: 1,
    fontSize: 22,
    fontFamily: 'WorkSans-Bold',
    textAlign: 'center',
    textAlignVertical: 'center',
  },
  input: {
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 5,
    width: "100%"
  },
};